/**
 *  PickupAnimation
 *
 *  Created by Legman on 11/05/2017.
 *
 */

import Common from "./Common";
import Powerup from "./powerups/Powerup";

/**
 * @class
 * @extends PIXI.Container
 */
export default class PickupSelector extends PIXI.Container {
    constructor(inputEnabled) {
        super();

        /**
         * @type {*}
         */
        this.signals = {};

        /**
         * @type {signals.Signal}
         */
        this.signals.select = new signals.Signal();

        /**
         * @type {Array}
         * @private
         */
        this._powerupTypes = Powerup.getRandomTypes();

        /**
         * @type {number}
         * @private
         */
        this._powerupIndex = 0;

        /**
         * @type {boolean}
         * @private
         */
        this._inputPressed = false;

        /**
         * @type {boolean}
         * @private
         */
        this._inputEnabled = inputEnabled;

        /**
         * @type {function}
         * @private
         */
        this._inputFunc = null;

        const assets = Common.assets;
        const orb = new PIXI.Sprite(assets.getTexture("game_powerup_bg"));
        orb.anchor = new PIXI.Point(0.5, 0.5);
        orb.scale = new PIXI.Point(0.8, 0.8);
        this.addChild(orb);
    }

    destroy(options) {
        this._inputEnabled && Common.input.signals.keyDown.remove(this._inputFunc);

        super.destroy(options);
    }

    /**
     */
    start() {
        let count = p3.Utils.randomInt(6, 12);

        const icon = new PIXI.Sprite(PIXI.Texture.EMPTY);
        icon.anchor = new PIXI.Point(0.5, 0.5);
        this.addChild(icon);

        function next(t) {
            delay(function() {
                this._powerupIndex ++;
                this._powerupIndex %= this._powerupTypes.length;
                const type = this._powerupTypes[this._powerupIndex];

                icon.texture = Powerup.getTexture(type);
                icon.scale = new PIXI.Point(0.5, 0.5);
                TweenMax.to(icon.scale, 0.18, {
                    x: 1,
                    y: 1,
                    ease: Back.easeOut,
                    easeParams: [4],
                    onComplete: function() {
                        if (-- count > 0) {
                            next.call(this, 0.02);
                        } else {
                            TweenMax.to(this.scale, 0.34, {
                                delay: 0.2,
                                x: 0,
                                y: 0,
                                ease: Back.easeIn,
                                easeParams: [1],
                                onComplete: function() {
                                    this.destroy();
                                },
                                onCompleteScope: this
                            });

                            const type = this._powerupTypes[this._powerupIndex];
                            this.signals.select.dispatch(this, type);

                            this.visible && Common.audio.playSound("sfx_powerup_selected_00");
                        }
                    },
                    onCompleteScope: this
                });

                this.visible && Common.audio.playSound("sfx_powerup_randomiser_loop_00");
            }, t, this);
        }
        next.call(this, 0);

        if (this._inputEnabled) {
            this._inputFunc = function(event) {
                if (!this._inputPressed && event.keyCode === 32) {
                    this._inputPressed = true;
                    count = 0;
                }
            };
            Common.input.signals.keyDown.add(this._inputFunc, this);
        }
    }

    /**
     * @returns {boolean}
     */
    get inputEnabled() {
        return this._inputEnabled;
    }
}
